import React, { useState } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";
class BrokerDetails extends React.Component {
  constructor(props) {
    super(props);
    console.log("====", this.props.brokerDetails);

    this.state = {
      brokerDetails:  this.props.brokerDetails,
    };
  }

  render() {
    return (
      <div className="tabHolder outsideAccordian mb-4 detailswithTwoLabels">
        <div className="row tabForm">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Broker Group
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.brokerDetails.groupDetails.name}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Broker 
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.brokerDetails.companyName}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Brokerage Logic
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.brokerDetails.brokerage_logic}
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Rate
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.brokerDetails.rate}
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                    Brokerage Months 
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.brokerDetails.brokerageMonths}
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      On Area 
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.brokerDetails.on_area}
                    </label>
                  </div>
                </div>
              </div>

              {
                this.state.brokerDetails.brokerage_logic ==  "Percentage of rent Basis" && (
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Percentage
                          <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {this.state.brokerDetails.brokerageMonths}
                        </label>
                      </div>
                    </div>
                  </div>
                )
              }
              

              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Brokerage Amount
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.brokerDetails.brokerageAmt}
                    </label>
                  </div>
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(BrokerDetails);
